export default {
    title: 'Войти',
    subtitle: 'У вас еще нет аккаунта?',
    sign_up: 'Зарегистрироваться',
    resend: 'Отправить письмо с подтверждением повторно',
    messages: {
        success: 'Email успешно подтвержден!',
        error: 'Ваша сессия истекла!',
        invalid: 'Неверный email или пароль!',
        unverified: 'Не получили письмо?',
        invited: 'Приглашение успешно принято!',
        user_already_part_of_the_company: 'Вы уже являетесь частью компании',
        token_invalid: 'Запрос недействителен',
        verification_email_sent: 'Письмо с подтверждением отправлено',
        user_is_not_part_of_the_company: 'Вы не являетесь частью этой компании',
        invitation_unkown_or_used: 'Приглашение уже использовано или недействительно',
        email_already_verified: 'Электронная почта уже подтверждена!',
    },
    activating: 'Активация вашей учетной записи...',
}
